<header class="report-header">
		<h1 class="report-title">Battery Summary Report</h1>

		<div class="info-grid">
			<div class="info-row">
				<div class="info-cell"><strong>Date:</strong> {{ toDayDate }}</div>
				<div class="info-cell"><strong>Battery ID:</strong> {{device.config_info.truck_id}}</div>
			</div>
			<div class="info-row">
				<div class="info-cell"><strong>Site Name:</strong> {{ currentSite.name }}</div>
				<div class="info-cell"><strong>Battery SN:</strong> {{device.config_info.truck_sn}}</div>
			</div>
			<div class="info-row">
				<div class="info-cell">
					<strong>Address:</strong> {{ currentSite.address }}
				</div>
				<div class="info-cell"><strong>Manuf. Date:</strong> {{device.config_info.truck_manufacturing_month}}/{{device.config_info.truck_manufacturing_year}}</div>
			</div>
			<div class="info-row">
				<div class="info-cell"><strong>Period:</strong> {{period.from}} – {{period.to}}</div>
				<div class="info-cell"><strong>Battery Manuf:</strong> {{device.config_info.truck_manufacturer}}</div>
			</div>
			<div class="info-row">
				<div class="info-cell"><strong>Weeks of Operation:</strong> {{ allDailyDetails?.eq?.opportunities  || '-'}}</div>
				<div class="info-cell"><strong>Nominal Voltage:</strong> {{device.config_info.nominal_voltage}} V</div>
			</div>

			<div class="info-row">
				<div class="info-cell"><strong>Nominal Capacity:</strong> {{device.config_info.battery_capacity}} Ah</div>
				<div class="info-cell"></div>
			</div>
		</div>
	</header>
<div *ngIf="allDailyDetails?.isShippedDevice; else noData">
	<div class="report-wrapper" *ngIf="allDailyDetails">
		<div class="white-box main-black p-4 border-radius" >
			<h1 class="col-title">{{'battlinkDevice.perf_analytic.battery_life_metrics' | translate}}</h1>
			<app-battery-life-metrics [deviceData]="device"></app-battery-life-metrics>
		</div>

		<div class="white-box main-black border-radius" >
			<app-performance-score-widget
				[data]="utilizationScoreData"
				[devices]="device"
				[performance]="true"
				[toPrint]="true"
				[selectedPeriod]="printReportSummeryPeriodInfo.period"
			></app-performance-score-widget>
		</div>
		
		<div class="analytics-grid" *ngIf="allDailyDetails">
			<div class="column mt-4">
				<h2 class="col-title">Battery Usage Metrics</h2>
				<div class="card usage-box">
					<p class="perf-label">Average Daily Hourly Performance</p>
					<div class="donut-flex">
						<div class="donut-ring-bg" [style.background]="getDailyHoursGradient()">
							<div class="donut-inner"><strong>100%</strong><br><small>Daily Hours</small></div>
						</div>
						<ul class="legend">
							<li>
								<div class="first-li"><span class="dot blue"></span> In-Use</div>
								<span class="val-blue legend-val">{{ allDailyDetails.dailyHours?.inUse?.value }}</span>
								<span class="val-blue legend-pct">{{ allDailyDetails.dailyHours?.inUse?.percent }}</span>
							</li>
							<li>
								<div class="first-li"><span class="dot green"></span> Charge</div>
								<span class="val-blue legend-val">{{ allDailyDetails.dailyHours?.charge?.value }}</span>
								<span class="val-blue legend-pct">{{ allDailyDetails.dailyHours?.charge?.percent }}</span>
							</li>
							<li>
								<div class="first-li"><span class="dot gray"></span> Idle</div>
								<span class="val-blue legend-val">{{ allDailyDetails.dailyHours?.idle?.value }}</span>
								<span class="val-blue legend-pct">{{ allDailyDetails.dailyHours?.idle?.percent }}</span>
							</li>
						</ul>
					</div>

					<p class="perf-label">Average Daily Ah Performance</p>
					<div class="donut-flex">
						<div class="donut-ring-bg" [style.background]="getAhrGradient()">
							<div class="donut-inner"><strong style="color: #8e44ad;">{{allDailyDetails.dailyAhr?.returnedPer}}</strong><br><small>Returned</small></div>
						</div>
						<ul class="legend"> 
							<li>
								<div class="first-li"><span class="dot blue"></span> InUse Ah</div>
								<span class="val-blue legend-val">{{ allDailyDetails.dailyAhr?.inUse?.value }}</span>
								<span class="val-blue legend-pct">{{ allDailyDetails.dailyAhr?.inUse?.percent }}</span>
							</li>
							<li>
								<div class="first-li"><span class="dot green"></span> Charge Ah</div>
								<span class="val-blue legend-val">{{ allDailyDetails.dailyAhr?.charge?.value }}</span>
								<span class="val-blue legend-pct">{{ allDailyDetails.dailyAhr?.charge?.percent }}</span>
							</li>
						</ul>
					</div>

					<p class="perf-label">Max Daily Usage</p>
					<div class="max-bar">
						<div class="bar-label">Max Daily In-Use Hours</div>
						<div class="bar-path">
							<div class="container-path-val"><span class="path-val val-blue">{{allDailyDetails.maxDaily?.inUseHours}}</span></div>
							<div class="rail">
								<div class="fill bg-blue" [style.width]="clampPercent(allDailyDetails.maxDaily?.inUseHoursPercent)"></div>
							</div>
							<span class="path-per val-blue">{{allDailyDetails.maxDaily?.inUseHoursPercent}}</span>
						</div>
					</div>
					<div class="max-bar">
						<div class="bar-label">Max Daily In-Use Amp-Hours</div>
						<div class="bar-path">
							<div class="container-path-val"><span class="path-val val-green">{{allDailyDetails.maxDaily?.inUseAhr}}</span></div>
							<div class="rail">
								<div class="fill bg-green" [style.width]="clampPercent(allDailyDetails.maxDaily?.inUseAhrPercent)"></div>
							</div>
							<span class="path-per val-blue">{{allDailyDetails.maxDaily?.inUseAhrPercent}}</span>
						</div>
					</div>
					<div class="max-bar">
						<div class="bar-label">Max Daily Available Amp-Hours</div>
						<div class="bar-path">
							<div class="container-path-val"><span class="path-val val-orange">{{allDailyDetails.maxDaily?.availableAhr}}</span></div>
							<div class="rail">
								<div class="fill bg-orange" style="width: 100%"></div>
							</div>
							<span class="path-per val-orange">100%</span>
						</div>
					</div>
				</div>

				<div class="card opp-card" *ngIf="allDailyDetails.opportunity?.show">
					<p class="perf-label">Opportunity / Fast Charge Metrics</p>
					<div class="opp-row">
						<div class="d-flex justify-content-between">
							<label>Daily Plug-In Target > {{ allDailyDetails.opportunity?.plugInTargetSiteSettings }}</label>
							<span class="text-green">{{allDailyDetails.opportunity?.pluginTarget}}</span>
						</div>
						<div class="full-rail">
							<div class="full-fill bg-green" [style.width]="clampPercent(allDailyDetails.opportunity?.pluginTarget)"></div>
						</div>
					</div>
					<div class="opp-row">
						<div class="d-flex justify-content-between">
							<label>Low SOC < {{ allDailyDetails.opportunity?.lowSocSiteSettings }}%</label>
							<span class="text-orange">{{allDailyDetails.opportunity?.lowSoc}}</span>
						</div>
						<div class="full-rail">
							<div class="full-fill bg-orange" [style.width]="clampPercent(allDailyDetails.opportunity?.lowSoc)"></div>
						</div>
					</div>
				</div>
			</div>

			<div class="column mt-4">
				<h2 class="col-title">Battery Performance Metrics</h2>
				<div class="card perf-box">
					<div class="perf-sect">
						<p class="perf-label">Temperature Distribution</p>
						<div class="perf-graph">
							<div class="perf-rows">
								<div class="p-row">
									<span>< 115°F</span>
									<div class="bar-container">
										<div class="p-bar bg-green" [style.width]="clampPercent(allDailyDetails.temperature?.normal)"></div>
										<span class="percent-text">{{ allDailyDetails.temperature?.normal }}</span>
									</div>
								</div>
								<div class="p-row">
									<span>115-130°F</span>
								<div class="bar-container">
									<div class="p-bar bg-yellow" [style.width]="clampPercent(allDailyDetails.temperature?.warm)"></div>
									<span class="percent-text">{{ allDailyDetails.temperature?.warm }}</span>
								</div>
								</div>
								<div class="p-row">
									<span>> 130°F</span>
									<div class="bar-container">
										<div class="p-bar bg-red" [style.width]="clampPercent(allDailyDetails.temperature?.hot)"></div>
										<span class="percent-text">{{ allDailyDetails.temperature?.hot }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="perf-sect">
						<p class="perf-label">EQ Performance</p>
						<div class="perf-graph">
							<div class="perf-rows">
								<div class="p-row">
									<span>EQ Opportunities</span>
									<div class="bar-container">
										<div class="p-bar bg-green" style="width: 100%"></div>
										<span class="percent-text">{{ allDailyDetails.eq?.opportunities }}</span>
									</div>
								</div>
								<div class="p-row">
									<span>EQ Performed</span>
									<div class="bar-container">
										<div class="p-bar bg-yellow" [style.width]="clampPercent(allDailyDetails.eq?.performedPercent)"></div>
										<span class="percent-text">{{ allDailyDetails.eq?.performed }} - {{ allDailyDetails.eq?.performedPercent }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="perf-sect">
						<p class="perf-label">Battery Water Level</p>
						<div class="perf-graph">
							<div class="perf-rows">
								<div class="p-row">
									<span>High Water Level Days</span>
									<div class="bar-container">
										<div class="p-bar bg-green" [style.width]="clampPercent(allDailyDetails.water?.high)"></div>
										<span class="percent-text">{{allDailyDetails.water?.highCount}} - {{allDailyDetails.water?.high}}</span>
									</div>
								</div>
								<div class="p-row">
									<span>Low Water Level Days</span>
									<div class="bar-container">
										<div class="p-bar bg-yellow" [style.width]="clampPercent(allDailyDetails.water?.low)"></div>
										<span class="percent-text">{{allDailyDetails.water?.lowCount}} - {{allDailyDetails.water?.low}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="perf-sect no-border">
						<p class="perf-label">In Use End Voltages</p>
						<div class="perf-graph">
							<div class="perf-rows">
								<div class="p-row">
									<span>> 1.9 VPC</span>
									<div class="bar-container">
										<div class="p-bar bg-green" [style.width]="clampPercent(allDailyDetails.endVoltage?.high?.percent)"></div>
										<span class="percent-text">{{allDailyDetails.endVoltage?.high?.percent}}</span>
									</div>
								</div>
								<div class="p-row">
									<span>1.75 - 1.9 VPC</span>
									<div class="bar-container">
										<div class="p-bar bg-yellow" [style.width]="clampPercent(allDailyDetails.endVoltage?.mid?.percent)"></div>
										<span class="percent-text">{{allDailyDetails.endVoltage?.mid?.percent}}</span>
									</div>
								</div>
								<div class="p-row">
									<span>< 1.75 VPC</span>
									<div class="bar-container">
										<div class="p-bar bg-red" [style.width]="clampPercent(allDailyDetails.endVoltage?.low?.percent)"></div>
										<span class="percent-text">{{allDailyDetails.endVoltage?.low?.percent}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="charts-container mt-5">
		<div *ngIf="tempData?.length">
			<sct-charts
				[type]="'ColumnChart'"
				[title]="'Max Temperature Heat Map'"
				[columnNames]="tempColumns"
				[data]="tempData"
				[options]="tempChartOptions"
				[height]="200">
			</sct-charts>
			<div class="temp-legend">
				<div class="legend-item">
					<span class="legend-color light-blue"></span>
					<span>&lt; 100°F (Light Blue)</span>
				</div>

				<div class="legend-item">
					<span class="legend-color light-brown"></span>
					<span>100–115°F (Light Brown)</span>
				</div>

				<div class="legend-item">
					<span class="legend-color yellow"></span>
					<span>116–129°F (Yellow)</span>
				</div>

				<div class="legend-item">
					<span class="legend-color red"></span>
					<span>&gt; 129°F (Red)</span>
				</div>
			</div>
		</div>

		<div *ngIf="socData?.length">
			<sct-charts
				[type]="'ColumnChart'"
				[title]="'In-Use % SOC Heat Map'"
				[columnNames]="socColumns"
				[data]="socData"
				[options]="socChartOptions"
				[height]="200">
			</sct-charts>
			<div class="temp-legend">
				<div class="legend-item">
					<span class="legend-color green"></span>
					<span>SOC >= {{ allDailyDetails.opportunity?.lowSocSiteSettings }}%</span>
				</div>

				<div class="legend-item">
					<span class="legend-color soc-red"></span>
					<span> SOC < {{ allDailyDetails.opportunity?.lowSocSiteSettings }}%</span>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #noData class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>